import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Text,
} from "@chakra-ui/react";

import { CloseIcon } from "@/components/icons";
import { LogsButton } from "@/components/Button";

const IncompleteDrawer = ({
  rejectionReasons,
  isOpen,
  onClose,
  isRejected,
}: {
  rejectionReasons: { reason: string }[];
  isOpen: boolean;
  onClose: () => void;
  isRejected: boolean;
}) => {
  return (
    <Drawer
      isOpen={isOpen}
      placement="bottom"
      onClose={onClose}
      autoFocus={false}
    >
      <DrawerOverlay />
      <DrawerContent
        sx={{
          padding: "30px 20px",
          background: "#fff",
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
        }}
      >
        <DrawerBody
          sx={{
            padding: "0",
          }}
        >
          <Box
            sx={{
              position: "relative",
            }}
          >
            <CloseIcon
              onClick={onClose}
              style={{
                position: "absolute",
                top: "50%",
                right: "0px",
                width: "16px",
                height: "16px",
                cursor: "pointer",
                color: "#333",
                transform: "translateY(-50%)",
              }}
            ></CloseIcon>
            <Flex align={"center"} justify={"center"}>
              <Text
                sx={{
                  color: isRejected ? "#F13434" : "#D8572B",
                  fontSize: "24px",
                  fontWeight: 700,
                }}
              >
                {isRejected ? "Rejected" : "Incomplete"}
              </Text>
            </Flex>
          </Box>{" "}
          <Box
            sx={{
              marginTop: "20px",
            }}
          >
            {rejectionReasons.map((item, index) => (
              <Text
                key={index}
                sx={{
                  color: "#848484",
                  textAlign: "justify",
                  fontFamily: "DIN",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 700,
                  marginTop: "10px",
                  padding: "0 16px",
                  position: "relative",
                  "&:before": {
                    content: '""',
                    display: "inline-block",
                    width: "7px",
                    height: "7px",
                    background: "#D8572B",
                    borderRadius: "50%",
                    position: "absolute",
                    left: "0",
                    top: "5px",
                    // transform: "translateY(-50%)",
                  },
                }}
              >
                {item.reason}
              </Text>
            ))}
          </Box>
          <LogsButton
            sx={{
              marginTop: "20px",
              fontSize: "20px",
              fontStyle: "normal",
              fontWeight: 500,
            }}
            onClick={onClose}
          >
            Got it
          </LogsButton>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default IncompleteDrawer;
